import { computed, Directive, input } from '@angular/core';

import { injectSchemaResolver } from '../address/schema-resolver';
import { DataState } from '../model/data-state';

@Directive()
export abstract class SchemaComponentBaseComponent<TConfig = unknown, TData = unknown> {
  readonly config = input<TConfig>();
  readonly state = input<DataState<TData>>();

  /**
   * What the config addresses, read from the state this component was handed — `this.schema.read(this.config()?.valuePath)`
   * inside a `computed`. Bound here so a component written later reads any address without knowing what the resolver
   * needs. Declared after `state`, which it binds.
   */
  protected readonly schema = injectSchemaResolver(this.state);

  protected readonly isLoading = computed(() => this.state()?.status === 'loading');
}
